const ABFieldAutoIndexCore = require("../../core/dataFields/ABFieldAutoIndexCore");
module.exports = class ABFieldAutoIndex extends ABFieldAutoIndexCore {};
